import api from "../../../../utils/api";

const FormApi = {
  // get lead by id
  async userEmailAndModbileCheckExistance(params = {}) {
    console.log("API CALL", params);
    const response = await api.get(`/public-forms/profilling-form/details`, {
      params,
    });
    return response?.data?.data;
  },

  async submitProfilingFormData(data, id) {
    const response = await api.post(
      `/public-forms/profilling-form/${id}`,
      data
    );
    return response?.data?.data;
  },

  async createLead(data) {
    try {
      console.log("Creating lead with data:", data);
      // take some variable from env
      const ofCompany = process.env.REACT_APP_OF_COMPANY;
      const productCategory = process.env.REACT_APP_PRODUCT_CATEGORY;
      const productInterested = process.env.REACT_APP_PRODUCT_INTERESTED;
      data = {
        ...data,
        ofCompany,
        productCategory,
        productInterested,
        leadSource: "From F.P form",
        businessType: "B2C",
      };
      const response = await api.post(`/lead/leadform/form?format=json`, data);
      return response?.data?.data;
    } catch (error) {
      console.error("Error creating lead:", error);
      throw error;
    }
  },
};

export default FormApi;
